import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconCheckBox from '../../../../../images/various/checkbox.svg';
import styles from './Integrations.module.scss';


const IntegrationItem = ({
  client,
  unlinkClient,
  logoUri
}) => {
  const [revoke, setRevoke] = useState(false);

  const mainClass = classNames({
    [styles.clients]: true,
    [styles.revokeBg]: revoke,
  });

  const logoClass = classNames({
    [styles.logoBgGrey]: client.linked && !client.enabled,
  });

  const toggleRevoke = () => {
    setRevoke(!revoke);
  };

  const handleClientUnlink = () => {
    unlinkClient(client.id);
    setRevoke(false);
  };

  return (
    <Fragment>
      <div className={mainClass}>
        <div className={styles.leftContent}>
          {
            revoke ? (
              <p className={styles.leftContentText__revoke}>Revoke access to {client.name}?</p>
            ) : (
              <Fragment>
                <img
                  className={logoClass}
                  src={logoUri}
                  alt={`${client.name} logo`}
                  height="auto"
                  width="118px"
                />
                <p className={styles.leftContentText}>{client.description}</p>
              </Fragment>
            )
          }
        </div>
        <div className={styles.rightContent}>
          {
            revoke ? (
              <Fragment>
                <span
                  role="button"
                  className={styles.logoLink__revoke}
                  onClick={toggleRevoke}
                >
                  No, Cancel
                </span>
                <span
                  role="button"
                  className={styles.logoLink__revoke}
                  onClick={handleClientUnlink}
                >
                  Yes, Revoke Access
                </span>
              </Fragment>
            ) : (
              <Fragment>
                {client.linked ? (
                  <Fragment>
                    {client.enabled ? (
                      <IconCheckBox
                        className={styles.checkboxImage}
                        height="24px"
                        width="24px"
                        onClick={toggleRevoke}
                      />
                    ) : (
                      <p
                        className={styles.disabledText}
                      >
                        DISABLED
                      </p>
                    )}
                  </Fragment>
                ) : (
                  <a
                    className={styles.logoLink}
                    href={client.homepageUri}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    VISIT SITE
                  </a>
                )}
              </Fragment>
            )
          }
        </div>
      </div>
    </Fragment>
  );
};

IntegrationItem.propTypes = {
  client: PropTypes.instanceOf(Object).isRequired,
  unlinkClient: PropTypes.func.isRequired,
  logoUri: PropTypes.string.isRequired,
};

export default IntegrationItem;
